import {useFluxStore} from 'client/framework';

import masqueradeStore from './Masquerade.store';

/** The masqueraded teacher's id for an `asEducatorId` argument; undefined when not masquerading. */
export const useAsEducatorId = (): string | undefined =>
  useFluxStore(masqueradeStore, (s) =>
    s.isMasquerading() ? (s.getUserIdByMasqueradeState() ?? undefined) : undefined
  );
